(function (Drupal) {
  'use strict';
  Drupal.behaviors.tableHeaderAccessibility = {
    attach: function (context, settings) {
      const tables = context.querySelectorAll('table');
      tables.forEach((table) => {
        const firstCell = table.querySelector('td, th');
        if (
          firstCell &&
          firstCell.tagName === 'TH' &&
          firstCell.textContent.trim() === ''
        ) {
          const td = document.createElement('td');
          // Copy attributes from th to td
          Array.from(firstCell.attributes).forEach(attr => {
            td.setAttribute(attr.name, attr.value);
          });
          td.innerHTML = firstCell.innerHTML;
          firstCell.parentNode.replaceChild(td, firstCell);
        }
      });
    }
  };
})(Drupal);
